import { useEffect } from 'react'

import {
  DSBreadcrumb,
  DSBreadcrumbItem,
  DSContainer,
  DSTab
} from '@vr/ds-react'
import { useSearchParams } from 'react-router-dom'

import CollectView from './collect'
import DeliveryView from './delivery'
import GeneralView from './general'
import ReportView from './report'
import { Label, Item } from './styled'
import { CollectProvider } from '@/contexts/collect.context'
import { DeliveryProvider } from '@/contexts/delivery.context'
import { GeneralProvider } from '@/contexts/general.context'
import { ReportProvider } from '@/contexts/report.context'
import useLocalStorage from '@/hooks/use-local-storage'

export const Home = () => {
  const [, setUser] = useLocalStorage('user', {})
  const [searchParams] = useSearchParams()
  const userName = searchParams.get('userName')
  const userId = searchParams.get('userId')

  useEffect(() => {
    setUser({ userId, userName })
  }, [userId, userName])

  const items: DSBreadcrumbItem[] = [
    {
      label: 'Página inicial'
    },
    {
      label: 'Pedidos'
    },
    {
      label: 'Acompanhar logística'
    }
  ]

  return (
    <DSContainer css={{ marginTop: '40px' }}>
      <DSBreadcrumb items={items} />
      <Label as='h1'>Painel de acompanhamento logístico</Label>

      <DSTab defaultValue='geral'>
        <DSTab.List>
          <Item value='geral'>Geral</Item>
          <Item value='coletas'>Coletas</Item>
          <Item value='entregas'>Entregas</Item>
          <Item value='relatorio'>Relatório</Item>
        </DSTab.List>
        <DSTab.Content value='geral'>
          <GeneralProvider>
            <GeneralView />
          </GeneralProvider>
        </DSTab.Content>
        <DSTab.Content value='coletas'>
          <CollectProvider>
            <CollectView />
          </CollectProvider>
        </DSTab.Content>
        <DSTab.Content value='entregas'>
          <DeliveryProvider>
            <DeliveryView />
          </DeliveryProvider>
        </DSTab.Content>
        <DSTab.Content value='relatorio'>
          <ReportProvider>
            <ReportView />
          </ReportProvider>
        </DSTab.Content>
      </DSTab>
    </DSContainer>
  )
}
